import { GregorioNoteElement } from './GregorioNoteElement';
import { GregorioMiscElementInfo } from './GregorioSyllable';
import { GregorioType } from '../enums/GregorioType';
import { GregorioNoteGlyph } from './GregorioNoteGlyph';

export class GregorioGlyph {
  misc!: GregorioMiscElementInfo;
  notes!: GregorioNoteGlyph;

  /* index to a string containing a possible TeX verbatim; necessary during
   * structure generation. */
  // texverb: number;

  /* type can have the values explained in the comment just above. */
  type!: GregorioType;

  /* There is no additional parameter for GRE_SPACE in a gregorio_glyph
   * because gregorio_space in this case can have only one value:
   * SP_ZERO_WIDTH, as other spaces would break the glyphs into
   * different elements. */


  get isSingleNote(): boolean {
    return this.notes.notes.length === 1;
  }

  get firstNote(): GregorioNoteElement | undefined {
    return this.notes?.first_note;
  }

  get lastNote(): GregorioNoteElement | undefined {
    return this.notes?.last_note;
  }

  get hasEpisema(): boolean {
    if (!this.notes) {
      return false;
    }
    return this.notes.allNotes.some(note => note.h_episema_above || note.h_episema_below);
  }

  get hasVEpisema(): boolean {
    return this.notes.allNotes.some(note => note.v_episema_height);
  }

  private _visualizersCount = 0;

  get visualizersCount(): number {
    return this._visualizersCount;
  }

  addVisualizers(count: number) {
    this._visualizersCount += count;
  }
}
